import React from 'react'
import { useTranslation } from 'react-i18next'

import LabelValue from '../../../packages/kiti/components/presentation/LabelValue'
import Tooltip from '../../../packages/kiti/components/presentation/Tooltip'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Text from '../../../packages/kiti/components/presentation/Text'
import FlexGrid from '../../../components/structure/FlexGrid'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'

const Content = ({ value, t }) => {
  if (!value?.item) return <></>

  return (
    <Grid gutter={0.5} paddingH={0.5}>
      <Col width="max-content">
        <LabelValue label={t('tooltip.item')} size="xsmall" value={value.item.name} truncate={20} />
      </Col>
      <Col width="max-content">
        <LabelValue label={t('tooltip.amount')} size="xsmall" value={value.amount} />
      </Col>
      <Col width="max-content">
        <LabelValue label={t('tooltip.operation')} size="xsmall" value={value.operationType.name} />
      </Col>
    </Grid>
  )
}

const ErrorContent = ({ value, t }) => {
  if (!value) return false

  return (
    <Grid gutter={0.5} paddingH={0.5}>
      <Col width="max-content">
        <LabelValue label={t('tooltip.error')} size="xsmall" value={value} />
      </Col>
    </Grid>
  )
}

export default function StockItemTooltip({ value }) {
  const { t } = useTranslation('editStocks')
  let errorMessage

  if (!!value.error && value.error === 'insufficient_amount') {
    errorMessage = t('statusTag.insufficientAmount')
  } else if (!!value.error && value.error === 'value_lte_zero') {
    errorMessage = t('statusTag.amountGreaterThanZero')
  } else {
    errorMessage = value.error
  }

  return (
    <FlexGrid justify="flex-start" gutter={0.2}>
      <Col>
        {!!value.error && !!errorMessage && (
          <Tooltip content={<ErrorContent value={errorMessage} t={t} />} label={' '} position="right">
            <Icon name={'BsInfoCircle'} color={'red'} size={0.8} />
          </Tooltip>
        )}
      </Col>
      <Tooltip content={<Content value={value} t={t} />} label={' '} position="left">
        <Text size="small" truncate={19}>
          {value?.item?.name}
        </Text>
      </Tooltip>
    </FlexGrid>
  )
}
